import PropTypes from "prop-types";
import { createContext, useContext, useLayoutEffect, useState } from "react";
import { useLocation } from "react-router-dom";

BreadcrumbProvider.propTypes = {
    children: PropTypes.node
};

const BreadcrumbContext = createContext({
    breadcrumbs: [],
    setBreadcrumbs: () => { }
});

export function BreadcrumbProvider({ children }) {
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    const location = useLocation();

    useLayoutEffect(() => {
        setBreadcrumbs([]);
    }, [location.pathname]);

    return (
        <BreadcrumbContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
            {children}
        </BreadcrumbContext.Provider>
    );

}

export const useBreadcrumbs = () => useContext(BreadcrumbContext);